import { Controller } from "@hotwired/stimulus"

// Handles clearing secret fields in integrations form
// When "Clear" is clicked, sets a hidden field to signal the controller to clear the value
export default class extends Controller {
  static targets = ["input", "hidden"]

  clear() {
    // Set the hidden field to "1" to signal clearing
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = "1"
    }

    // Update the input placeholder to show it will be cleared
    if (this.hasInputTarget) {
      this.inputTarget.placeholder = "(will be cleared on save)"
      this.inputTarget.classList.add("bg-red-50", "dark:bg-red-900/20", "border-red-300", "dark:border-red-700")
      this.inputTarget.disabled = true
    }

    // Change button to "Undo"
    this.element.querySelector("button").textContent = "Undo"
    this.element.querySelector("button").dataset.action = "clearable-field#undo"
  }

  undo() {
    // Reset the hidden field
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = "0"
    }

    // Reset the input appearance
    if (this.hasInputTarget) {
      this.inputTarget.placeholder = "••••••••••••"
      this.inputTarget.classList.remove("bg-red-50", "dark:bg-red-900/20", "border-red-300", "dark:border-red-700")
      this.inputTarget.disabled = false
    }

    // Change button back to "Clear"
    this.element.querySelector("button").textContent = "Clear"
    this.element.querySelector("button").dataset.action = "clearable-field#clear"
  }
}
